import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { parsePath, byCode, pageNamespace } from "@/i18n/config";
import { ensureLanguage } from "@/i18n";
import { setAlternates } from "@/lib/seo";
import { api } from "@/lib/api";

// Reads the language prefix from the URL (authoritative), loads the bundle, sets i18n + <html lang>,
// and emits per-page reciprocal hreflang/x-default alternates. A non-English page is only
// indexable + hreflang-eligible when its OWN content namespace is Approved for that language;
// otherwise it stays noindex and out of the alternates set (incomplete pages excluded).
export default function LangRoute({ children }) {
  const location = useLocation();
  const { code } = parsePath(location.pathname);
  const [published, setPublished] = useState({});

  useEffect(() => {
    api.get("/i18n/meta/published").then((r) => setPublished(r.data.published || {})).catch(() => {});
  }, []);

  useEffect(() => {
    ensureLanguage(code);
    document.documentElement.setAttribute("lang", byCode(code).htmlLang);
    try { localStorage.setItem("uni_lang", code); } catch (e) { /* noop */ }
  }, [code]);

  useEffect(() => {
    const ns = pageNamespace(location.pathname);
    if (ns === "private") { setAlternates(location.pathname, [], { skip: true }); return; }
    // languages whose version of THIS page is fully approved (own namespace, not just global)
    const eligible = Object.keys(published).filter((l) => (published[l] || []).includes(ns));
    const incomplete = code !== "en" && !eligible.includes(code);
    setAlternates(location.pathname, eligible, { noindex: incomplete });
  }, [location.pathname, published, code]);

  return children;
}
